<template>
    <div class="lp_Detail">
      <div class="title" v-if="dataInfo[dataMap.title]">
        <p>{{ dataInfo[dataMap.title] }}</p>
        <p>
          <slot>
            <span v-if="dataInfo[dataMap.type]">{{ dataInfo[dataMap.type] }}</span>
            <span v-if="dataInfo[dataMap.from]">来源：{{ dataInfo[dataMap.from] }}</span>
            <span v-if="dataInfo[dataMap.deployTime]">发布时间：{{ dataInfo[dataMap.deployTime] | translatDateToDayPointStr }}</span>
            <span v-if="dataInfo[dataMap.validEndTime]">有效期至：{{ dataInfo[dataMap.validEndTime] | translatDateToDayPoint }}</span>
            <!-- 高新风采没有阅读量 -->
            <span v-if='detailType!=5'>阅读量：{{ Number(dataInfo[dataMap.readNumber] || 0)+Number(dataInfo[dataMap.originReadCount] || 0 ) }}</span>
             
          </slot>
        </p>
      </div>

      <div class="content">
        <div v-html="dataInfo[dataMap.content]"></div>
        <!-- 政策原文文件 -->
        <div class="originArticle" v-if="dataInfo.policyOriginFile">
          <div class="label">政策文件：</div>
          <div class="info">
            <a :href="dataInfo.policyOriginFile" target="_blank" >政策原文.pdf</a>
          </div>
        </div> 
        <!-- 政策原文描述 -->
        <div class="originArticle" v-if="dataInfo.originFileContent">
          <div class="label">政策原文：</div>
          <div class="info">
            {{ dataInfo.originFileContent }}
          </div>
        </div> 
          <!-- 
            当页面详情----1政策解读或4第三方服务时，
            若未登录-显示按钮；若登录了且账号类型为企业时-显示按钮
           -->
        <div v-if="(hostKey===null||hostKey===''||hostKey==='front')" class="bottomView">
          <!-- data里面isApplyable表示申请，其它表示咨询 -->
            <!-- 政策解读 -->
            <!-- 根据发布政策时选择的类型显示3个入口
            可申报：前端显示“我要申请”“我要咨询”2个按钮
            评审资料预审核：前端显示“评审资料提交”“我要咨询”2个按钮
            仅咨询：前端显示“我要咨询”1个按钮 -->
          <!-- 现在政策和第三方服务一样设置 -->
            <div  class="bottomView" v-if='detailType==1||detailType==4'>
              <p  @click="btnAction(detailType,1)" class="applyLp" v-if='dataInfo.applyType==1'>我要申请</p>
              <p  @click="btnAction(detailType,2)" class="applyLp" >我要咨询</p>
              <p  @click="btnAction(detailType,3)" class="applyLp" v-if='dataInfo.applyType==2'>评审资料</p>
            </div>
        </div>
        <!-- 右侧按钮 -->
        <div class="bottomViewRightBox" v-if="(hostKey===null||hostKey===''||hostKey==='front')" >
          
          <!-- data里面isApplyable表示申请，其它表示咨询 -->
            <!-- 政策解读 -->
            <!-- 根据发布政策时选择的类型显示3个入口
            可申报：前端显示“我要申请”“我要咨询”2个按钮
            评审资料预审核：前端显示“评审资料提交”“我要咨询”2个按钮
            仅咨询：前端显示“我要咨询”1个按钮 -->
             <!-- v-if="dataInfo.isApplyable" 稍后可能使用这个参数判断显示不显示 -->
            <div v-if='detailType==1||detailType==4'>
             <div class="bottomViewRight"   @click="btnAction(detailType,1)" v-if='dataInfo.applyType==1'>
              <img :src="editImg" alt="edit">
              <span>我要申请</span>
            </div>
            <div class="bottomViewRight" @click="btnAction(detailType,2)" >
                <img :src="editImg" alt="edit">
                <span>我要咨询</span>
            </div>
            <div class="bottomViewRight" @click="btnAction(detailType,3)" v-if='dataInfo.applyType==2'>
                <img :src="editImg" alt="edit">
                <span>评审资料</span>
            </div>
            </div>
        </div>
        
      </div>
    </div>
</template>

<script>
  export default {
    name: "lp_Detail",
    props:{
      //详情数据
      dataInfo:{
        type:Object,
        default:()=>{}
      },
      //数据key对照表
      dataMap:{
        type:Object,
        default:()=>{
          return{
            type:'type',//类型
            title:'title',//标题
            deployTime:'createTime',//发布时间
            validEndTime:'validEndTime',//有效期至
            content:'synopsis',//内容
            readNumber:'readCount',//阅读量
            originReadCount:'originReadCount',
            from: 'informFrom',
          }
        }
      },
      detailType:{
        type:Number,
        default:0
      }
    },
    data () {
      return{
        editImg:require('../../assets/images/edit.png'),
      }
    },
    computed: {
      // 判断账号类型
      hostKey(){
          return this.$store.state.hostKey;
      }
    },
    methods: {
      // type--1政策解读*  4第三方服务*  orderType 1.申请 2.咨询 3.评审
    btnAction(type,orderType){
      if(!this.$store.state.username){
        // 未登录-显示登录弹窗
        this.$store.commit('SET_LOGIN',true);
        // 显示企业登录窗口
        this.$store.commit('SET_ONLYENTERPRISELOGIN',true);
        return
      }

        let viewS=["/policyApply/","/policyConsultView/","/policyReview/"];//我要申请，我要咨询，评审资料
        const { params:{code}}=this.$route;
        this.$store.dispatch('checkInState',{
          toUrl:`${viewS[orderType-1]}${code}`,
          type:0, //1.外链新打开页面 0.内链
          query:{type:type,title:this.dataInfo[this.dataMap.title],orderType }
          });
    }
    } 
  }
</script>

<style scoped lang="less">
.lp_Detail{
  width: 100%;
  background: #fff;
  padding:30px 40px;
  box-sizing: border-box;
  .applyLp{
    margin: 0px 20px;
  }
  .title{
    text-align: center;
    width: 100%;
    padding: 0px 30px;
    box-sizing: border-box;
    border-bottom: 1px solid  #E5E5E5;
    p{
      font-family: MicrosoftYaHeiUI;
      font-size: 26px;
      color: #333333;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      span{
        font-family: MicrosoftYaHeiUI;
        font-size: 12px;
        color: #666666;
        text-align: center;
        margin: 16px 12px;
      }
    }
  }
  // 内容显示和操作按钮
  .content{
    width: 100%;
    margin-top: 20px;
    height: 100%;
    /deep/ img{
      max-width: 100%!important;
      height: auto;
    }
    .originArticle{
      margin-top:20px;
      width: 100%;
      height: auto;
      padding: 16px 18px;
      box-sizing: border-box;
      display: flex;
      flex-wrap: wrap;
      background: #F9F9F9;
      .label{
        font-family: MicrosoftYaHeiUI;
        font-size: 14px;
        color: #333333;
        line-height: 28px;
      }
      .info {
        font-family: MicrosoftYaHeiUI;
        font-size: 14px;
        line-height: 28px;
        a{
          color: #1582F3;
        }
      }
    }
    // 底部-申请、咨询
    .bottomView{
      margin-top: 10px;
      width: 100%;
      // background: #F9F9F9;
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 30px;
    }
    .bottomViewRightBox{
      position: fixed;
      z-index: 99;
      right: 50%;
      margin-right: -700px;
      bottom: 258px;
    }
    // 右侧悬浮窗口
    .bottomViewRight{
        margin:20px 0px;
        width: 80px;
        height: 80px;
        background: #1890FF;
        border: 1px solid rgba(21,130,243,0.25);
        border-radius: 2px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        span{
          font-family: Alibaba-PuHuiTi-M;
          font-size: 14px;
          color: #FFFFFF;
          letter-spacing: 0;
          text-align: center;
          margin-top: 10px;
        }
    }
  }
  
  
}
</style>



// WEBPACK FOOTER //
// src/components/detail/index.vue